import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const palmRiverConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Palm River-Clair Mel Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Palm River-Clair Mel, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_palm_river_clair_mel',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Palm River-Clair Mel',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Palm River-Clair Mel Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     residential neighborhoods of <strong>Palm River-Clair Mel</strong>. Located 
     along the Palm River corridor in Southeast Hillsborough, this community 
     faces the double challenge of riverfront flooding and dense residential 
     tree growth. Waterlogged soil weakens root systems, storm winds stress 
     canopies, and trees in tight lots create hazards that need professional 
     attention before they cause damage.`,

    `We specialize in <strong>hazardous tree removal and precision trimming near 
     flood prone and riverfront properties</strong> trees with compromised roots 
     from repeated flooding, overhanging limbs near homes and fences, storm 
     cleanup, and full removals on tight residential lots. We handle the work 
     safely regardless of site conditions.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Palm River-Clair Mel</strong> and the surrounding 
     <strong>Southeast Tampa</strong> communities keeping your property 
     safe and your trees well managed all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Palm River-Clair Mel, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_PalmRiverClairMel = () => <LocationPage config={palmRiverConfig} />;
export default Services_PalmRiverClairMel;
